/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1SerieSerieidLangsId202,
  PutApiV1SerieSerieidLangsId400,
  PutApiV1SerieSerieidLangsId401,
  PutApiV1SerieSerieidLangsId404,
  PutApiV1SerieSerieidLangsId500,
  PutApiV1SerieSerieidLangsIdMutationRequest,
  PutApiV1SerieSerieidLangsIdMutationResponse,
  PutApiV1SerieSerieidLangsIdPathParams,
} from "../../types/serieIdiomasController/PutApiV1SerieSerieidLangsId.ts";
import { serieLangViewModelSchema } from "../serieLangViewModelSchema.ts";
import { updateSerieLangRequestViewModelSchema } from "../updateSerieLangRequestViewModelSchema.ts";

export const putApiV1SerieSerieidLangsIdPathParamsSchema = z.object({
  serieId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1SerieSerieidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1SerieSerieidLangsId202Schema = z.lazy(
  () => serieLangViewModelSchema,
) as unknown as ToZod<PutApiV1SerieSerieidLangsId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1SerieSerieidLangsId400Schema =
  z.any() as unknown as ToZod<PutApiV1SerieSerieidLangsId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1SerieSerieidLangsId401Schema =
  z.any() as unknown as ToZod<PutApiV1SerieSerieidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1SerieSerieidLangsId404Schema =
  z.any() as unknown as ToZod<PutApiV1SerieSerieidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1SerieSerieidLangsId500Schema =
  z.any() as unknown as ToZod<PutApiV1SerieSerieidLangsId500>;

export const putApiV1SerieSerieidLangsIdMutationRequestSchema = z.lazy(
  () => updateSerieLangRequestViewModelSchema,
) as unknown as ToZod<PutApiV1SerieSerieidLangsIdMutationRequest>;

export const putApiV1SerieSerieidLangsIdMutationResponseSchema = z.lazy(
  () => putApiV1SerieSerieidLangsId202Schema,
) as unknown as ToZod<PutApiV1SerieSerieidLangsIdMutationResponse>;
